import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/settings/${id}`)
    },
    update(id, params) {
        return Vue.axios.post(`/settings/update/${id}`, params)
    },
    debugLogs(id, params = {}) {
        return Vue.axios.get(`/settings/${id}/debug-logs`, {params})
    },
    testSend(id, userId, params = {}) {
        return Vue.axios.post(`/settings/${id}/test-send`, {user_id: userId, ...params})
    },
    searchTestUsers(pattern) {
        return Vue.axios.get(`/notifications-search-users`, {params: {pattern}})
    },
    uploadPushFirstImage(file) {
        const data = new FormData();
        data.append('image', file);

        return Vue.axios.post(`/settings/push-first/image`, data, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
    },
    exportGlovoMenu() {
        return Vue.axios.get(`/export/glovo?is_jpg=yes`)
    },
    exportEshoGlovoMenu() {
        return Vue.axios.get(`/export/glovo/esho?is_jpg=yes`)
    },
    uploadVideo(file) {
        const data = new FormData();
        data.append('video', file);

        return Vue.axios.post(`/settings/upload-video`, data, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
